import React from 'react';
import { translate } from '../Services/translation';

const getTotal = (articles = []) => {
  var total = 0;
  articles.forEach((article, articleIndex) => {
    var variant = article.configVariants.filter(
      (x) => x.sku == article.defaultVariant
    )[0];
    if (variant != undefined) {
      total += variant.price * article.defaultAmmount;
    }
  });

  return total;
};

const getTotalList = (articles = []) => {
  var total = 0;

  articles.forEach((article) => {
    var variant = article.configVariants.filter(
      (x) => x.sku == article.defaultVariant
    )[0];

    if (variant != undefined) {
      total += variant.listPrice * article.defaultAmmount;
    }
  });

  return total;
};
const isDisabled = (articles = []) => {
  var disabled = false;

  articles.forEach((article) => {
    var selected = article.configVariants.filter(
      (x) => x.sku == article.defaultVariant
    )[0];
    if (selected != undefined && selected.soldOut && article.defaultAmmount > 0) {
      disabled = true;
    }
  });

  return disabled;
};

const getDelivery = (articles = []) => {
  var statusCodes = [
    'RedMax',
    'RedHighest',
    'RedHigh',
    'RedMed',
    'RedLow',
    'Yellow',
    'Green',
  ];

  var status = '';
  var selectedArticles = [];
  articles.forEach((article) => {
    var selected = article.configVariants.filter(
      (x) => x.sku == article.defaultVariant
    )[0];
    if (selected != undefined) {
      selectedArticles.push(selected);
    }
  });

  statusCodes.forEach((code) => {
    if (status == '') {
      var article = selectedArticles.filter(
        (x) => x.deliveryStatus != null && x.deliveryStatus.startsWith(code)
      )[0];
      if (article != undefined) {
        status = article.deliveryText;
      }
    }
  });

  return status;
};

const ProductConfigurator = ({
  packagePriceNew,
  packagePriceOld,
  packagePriceNormal,
  isPackageProduct,
  articles,
  emptyArticles,
  increment,
  decrement,
  label,
  labelEmpty,
  cssClass,
  onClick,
  changeVariant,
  changeActiveArticle,
  baseProduct,
  children,
}) => {
  const configItemHeaderClick = (index) => {
    changeActiveArticle(articles[index].name);
  };

  const configurationClick = (oldId, newId) => {
    changeVariant(oldId, newId);
  };

  const notOrderableText = () =>
    isDisabled(articles) && (
      <p className="product-buy-box__not-orderable">
        {translate('productpage.notorderable', 'Produkten går för tillfället inte att beställa')}
      </p>
    );

  const getConfigurations = () => {
    return articles.map((article, articleIndex) => {
      return (
        <div className="option-holder" key={articleIndex}>
          <div className="header">
            {articleIndex + 1}.{' '}
            <a
              onClick={() => configItemHeaderClick(articleIndex)}
              className="toggle-options"
              style={{ cursor: 'pointer' }}
            >
              <span>{article.name}</span>
            </a>
          </div>
          <div
            className={
              article.active || article.active === undefined
                ? 'options active'
                : 'options'
            }
          >
            <div className="contents">
              {article.configVariants.map((configVariant, variantIndex) => {
                return (
                  <div
                    key={configVariant.sku + variantIndex}
                    style={{ cursor: 'pointer' }}
                    className="single"
                  >
                    <a
                      style={{ cursor: configVariant.soldOut ? 'not-allowed' : 'pointer' }}
                      aria-disabled={configVariant.soldOut}
                      onClick={() =>
                        !configVariant.soldOut &&
                        configurationClick(
                          article.defaultVariant,
                          configVariant.sku
                        )
                      }
                      className={[
                        article.defaultVariant == configVariant.sku ? 'active' : '',
                        configVariant.soldOut ? 'disabled' : '',
                      ].join(' ').trim()}
                    >
                      <div className="image">
                        <img src={configVariant.defaultImageUrl} alt="" />
                      </div>
                      <div className="name">{configVariant.name}</div>
                      {configVariant.deliveryStatus == 'RedMax' && (
                        <div className="stock-info sold-out">
                          {configVariant.deliveryText}
                        </div>
                      )}
                      {configVariant.deliveryStatus == 'RedHigh' && (
                        <div className="stock-info out-of-stock">
                          {configVariant.deliveryText}
                        </div>
                      )}
                      {configVariant.deliveryStatus == 'Green' && (
                        <div className="stock-info in-stock">
                          {configVariant.deliveryText}
                        </div>
                      )}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    });
  };

  const benefits = () => {
    return (
      <div className="usps-holder">
        <div className="usp">
          <span>✓</span> {translate('productpage.priceGuarantee')}
        </div>
        <div className="usp">
          <span>✓</span> {translate('productpage.freeShippingOver')}
        </div>
        <div className="usp">
          <span>✓</span> {translate('productpage.deliveryGuarantee')}
        </div>
        <div className="usp">
          <span>✓</span> {translate('productpage.fastDelivery')}
        </div>
      </div>
    );
  };

  const packagePriceWithBenefitsBlock = (
    packagePriceNew,
    packagePriceOld,
    packagePriceNormal
  ) => {
    if (packagePriceNew !== '' && packagePriceOld !== '') {
      return (
        <div
          className={
            isDisabled(articles) ? 'price-and-such disabled' : 'price-and-such'
          }
          key="package-price-new"
        >
          <div className="price">
            <span className="new">{packagePriceNew}</span>{' '}
            <span className="old">{packagePriceOld}</span>
          </div>
          {children}
          {notOrderableText()}
          {benefits()}
        </div>
      );
    } else {
      return (
        <div
          className={
            isDisabled(articles) ? 'price-and-such disabled' : 'price-and-such'
          }
          key="package-price-normal"
        >
          <div className="price">
            <span className="normal">{packagePriceNormal}</span>
          </div>
          {children}
          {notOrderableText()}
          {benefits()}
        </div>
      );
    }
  };

  const priceWithBenefitsBlock = (isTotalListPrice) => {
    if (isTotalListPrice)
      return (
        <div
          className={
            isDisabled(articles) ? 'price-and-such disabled' : 'price-and-such'
          }
        >
          <div className="price">
            <span className="new">
              {getTotal(articles)} {translate('productpage.currency')}
            </span>
            <span className="old">
              {getTotalList(articles)} {translate('productpage.currency')}
            </span>
          </div>
          {children}
          {notOrderableText()}
          {benefits()}
        </div>
      );
    else
      return (
        <div
          className={
            isDisabled(articles) ? 'price-and-such disabled' : 'price-and-such'
          }
        >
          <div className="price">
            <span className="normal">
              {getTotal(articles)} {translate('productpage.currency')}
            </span>
          </div>
          {children}
          {notOrderableText()}
          {benefits()}
        </div>
      );
  };
  if (isPackageProduct == 'True') {
    return (
      <div className="main-options">
        {getConfigurations()}
        {packagePriceWithBenefitsBlock(
          packagePriceNew,
          packagePriceOld,
          packagePriceNormal
        )}
      </div>
    );
  } else if (getTotalList(articles) != getTotal(articles))
    return (
      <div className="main-options">
        {getConfigurations()}
        {priceWithBenefitsBlock(true)}
      </div>
    );
  else
    return (
      <div className="main-options">
        {getConfigurations()}
        {priceWithBenefitsBlock(false)}
      </div>
    );
};

export default ProductConfigurator;
